import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";
import { ThemeProvider } from "@/contexts/ThemeContext";

window.__nativeFetch = window.fetch.bind(window);

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration({
        shouldCreateSpanForRequest: (url) => {
          return !(
            typeof url === "string" &&
            (url.includes("feelathomenow-website-v2.onrender.com/api/") ||
              url.includes("/api/platform/organizations"))
          );
        },
      }),
    ],
    tracesSampleRate: 0.1,
    environment: process.env.NODE_ENV,
    release: process.env.REACT_APP_RELEASE_VERSION,
  });
}

setInterval(() => {
  const badge = document.getElementById("emergent-badge");
  if (badge) {
    badge.remove();
  }
}, 500);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
